import { render } from "./ShipmentsSupplier.vue?vue&type=template&id=5f5738a0&scoped=true&ts=true"
import script from "./ShipmentsSupplier.vue?vue&type=script&lang=ts"
export * from "./ShipmentsSupplier.vue?vue&type=script&lang=ts"

import "./ShipmentsSupplier.vue?vue&type=style&index=0&id=5f5738a0&scoped=true&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5738a0"]])

export default __exports__